// extracted by mini-css-extract-plugin
module.exports = {"header":"src-containers-Form-SimplifiedBuilder-Internal-CollapsibleSection___header","settings":"src-containers-Form-SimplifiedBuilder-Internal-CollapsibleSection___settings"};